export const benefits = [
  {
    'imgClass': 'hand-in-hand-with-technology',
    'heading': 'Hand-in-Hand With Technology',
    'description': 'Technology and saving lives go hand-in-hand at Ketto! We continue to implement new and improved technology with the goal of helping as many people in need as we can.'
  },
  {
    'imgClass': 'people-centric',
    'heading': 'People-Centric Culture',
    'description': 'We make sure that people are always at the forefront. In addition to benefits, perks, incentives, and acknowledgement, we take a compassionate approach to leadership.'
  },
  {
    'imgClass': 'learn-and-shine',
    'heading': 'Learn and Shine On The Go',
    'description': 'With exceptional mentorship, you can expect to develop professionally and personally. Our priority is to guide and support our team because we’re invested in their growth.'
  }
];
